export interface DDNSStatusRequest {}

export enum DDNSProvider {
        DNSPod = 'DNSPod',
        Cloudflare = 'Cloudflare',
}

export enum DDNSActionName {
        Update = 'update',
}

export enum DDNSRecordStatus {
        Active = 'active',
        Error = 'error',
}

export interface DDNSRecordAction {
        type: string;
        label: string;
        actionName: DDNSActionName;
}
export interface DDNSRecord {
        recordType: string;
        status: DDNSRecordStatus;
        id: string;
        name: string;
        value: string;
        createdAt: string;
        updatedAt: string;
        ttl: number;
        provider: DDNSProvider;
        actions?: DDNSRecordAction[];
}
export interface DDNSStatusResponse {
        ddnsRecords: DDNSRecord[];
}
